import Vue from 'vue';
import Popper from 'vue-popperjs';
export default Vue.extend({
    components: { Popper },
    inheritAttrs: false,
    props: {
        // Internally, Popper will also be disabled if the "tooltip" string is empty - check the template above.
        disabled: { type: Boolean, default: false },
        tooltip: { type: String, required: false, default: null },
        options: { type: Object, required: false, default: () => ({ positionFixed: true }) },
    },
});
